import dayjs from "dayjs";
import { ref } from "vue";

export function shopIsOpen(open?: string, close?: string): boolean {
    if (!open || !close) {
        return false;
    }

    const timeStart = new Date(open);
    const timeEnd = new Date(close);
    const now = ref(new Date());

    return timeStart.getTime() <= now.value.getTime() && timeEnd.getTime() >= now.value.getTime();
}

export function shopState(open?: string, close?: string): 'open' | 'opening-soon' | 'closed' {
    if (!open || !close) {
        return 'closed';
    }

    const timeStart = dayjs(open);
    const timeEnd = dayjs(close);
    const now = dayjs();

    if (timeStart.isAfter(now)) {
        return 'opening-soon';
    }

    if (timeEnd.isAfter(now) && timeEnd.isAfter(now)) {
        return 'open';
    }

    return 'closed';
}
